import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { Invoice, InvoiceItem } from "../../../generated/graphql";

const InvoiceItems: React.FC<{ invoice: Invoice }> = ({ invoice }) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (((invoice?.invoiceItems || []) as InvoiceItem[]).length <= 0) {
    return <></>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <View style={[styles.itemRow]}>
          <Text
            style={[
              styles.itemCol,
              styles.itemHeader,
              { width: "45%", paddingLeft: 6 },
            ]}
          >
            Description
          </Text>
          <Text style={[styles.itemCol, styles.itemHeader, { width: "15%" }]}>
            Qty
          </Text>
          <Text style={[styles.itemCol, styles.itemHeader, { width: "20%" }]}>
            Cost
          </Text>
          <Text
            style={[
              styles.itemCol,
              styles.itemHeader,
              { width: "20%", paddingRight: 6 },
            ]}
          >
            Subtotal
          </Text>
        </View>
      </View>
      <View>
        {((invoice?.invoiceItems || []) as InvoiceItem[]).map((item, index) => {
          //   const discountValue = getTransactionItemDiscountValue(
          //     transactionItem as WorkOrderItem
          //   )
          const discountValue = 0;

          const isOdd = (index + 1) % 2 === 0;

          return (
            <View
              style={[
                styles.itemRow,
                { backgroundColor: isOdd ? "#f2f2f3" : "#fff" },
              ]}
              key={item?.id}
            >
              <Text style={[styles.itemCol, { width: "45%", paddingLeft: 6 }]}>
                {item?.itemName}
              </Text>
              <Text style={[styles.itemCol, { width: "15%" }]}>
                {formatter.format(item.qty)}
              </Text>
              <Text style={[styles.itemCol, { width: "20%" }]}>
                $ {formatter.format(item?.price)}
              </Text>
              <Text style={[styles.itemCol, { width: "20%", paddingRight: 6 }]}>
                $ {formatter.format((item?.price - discountValue) * item?.qty)}
              </Text>
            </View>
          );
        })}
      </View>
    </View>
  );
};

// Create styles
const styles = StyleSheet.create({
  container: {
    marginBottom: 8,
    fontFamily: "Poppins",
    fontSize: 8,
  },
  headerContainer: {
    backgroundColor: "#2fd5ee",
  },
  itemRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    gap: 5,
  },
  itemCol: {},
  itemHeader: {
    fontWeight: 600,
    color: "#fff",
    paddingTop: 8,
    paddingBottom: 8,
  },
});

export default InvoiceItems;
